module.exports = __webpack_public_path__ + "static/media/icon-gotmail-dark.9095d7ae.svg";